import { render, staticRenderFns } from "./CustomRow.vue?vue&type=template&id=4aa2b441&scoped=true"
var script = {}
import style0 from "./CustomRow.vue?vue&type=style&index=0&id=4aa2b441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa2b441",
  null
  
)

export default component.exports